import React from 'react';
import { connect } from 'react-redux';
import Content from './SingleProductContent';

const SingleProduct = props => props.isOpen ? <Content /> : null;

export default connect(state => ({
    isOpen: state.singleProductOpen
}))(SingleProduct);